import { styled } from 'styled-components';
import * as api from '../../api';
import { Shade30Color } from 'common/dist/styles/common';
import { getPrevisitAsset } from '../../utils/provider';

interface Props {
  provider: Pick<api.User.User, 'previsitImageUrl' | 'firstName' | 'lastName'>;
  url?: string;
  onLinkClicked?: () => void;
}

const ProviderImage: React.FC<Props> = ({ provider, url, onLinkClicked }) => {
  const getProviderImage = () => {
    if (provider.previsitImageUrl) {
      return (
        <ProviderAssetImage
          src={getPrevisitAsset(provider.previsitImageUrl)}
          alt={`${provider.firstName} ${provider.lastName}`}
          className="w-24 h-24 rounded-full"
        />
      );
    }
    return (
      <DefaultProviderImage>
        {provider.firstName ? provider.firstName[0] : ''}
        {provider.lastName ? provider.lastName[0] : ''}
      </DefaultProviderImage>
    );
  };

  return url ? (
    <Link
      target="_blank"
      href={url}
      rel="noreferrer"
      onClick={() => onLinkClicked?.()}
    >
      {getProviderImage()}
    </Link>
  ) : (
    getProviderImage()
  );
};

const Link = styled.a`
  height: 80px;
  min-height: 80px;
  min-width: 80px;
  width: 80px;
  text-decoration: none;
  color: var(--font-color);
`;

const ProviderAssetImage = styled.img`
  height: 80px;
  min-height: 80px;
  min-width: 80px;
  width: 80px;
  border-radius: 50%;
  object-fit: cover;

  @media (max-width: 680px) {
    height: 64px;
    width: 64px;
  }
`;

const DefaultProviderImage = styled.div`
  background-color: ${Shade30Color};
  height: 80px;
  width: 80px;
  min-width: 80px;
  min-height: 80px;
  border-radius: 50%;
  font-weight: bold;
  font-size: 22px;
  letter-spacing: 0.1em;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 680px) {
    height: 64px;
    width: 64px;
    min-width: 64px;
    min-height: 64px;
  }
`;

export default ProviderImage;
